import React from 'react'
import { View } from 'react-native'
interface SpaceHProps {
  size?: number;
}

const SpaceW: React.FC<SpaceHProps> = ({ size = 10 }) => {
  return <View style={{ width: size }} />
}

export default SpaceW
